import { gql } from '@apollo/client';
import { CreditStudyResponseDto } from '../../dtos';

export const GetUserCreditStudySchema = gql`
  query GetUserCreditStudy {
    getUserCreditStudy {
      value {
        id
        providedUserInfo {
          userId
          creditStudyId
          academicBackground
          declaredIncome
          maritalStatus
          declaresRent
          hasDependents
          dateOfBirth
          employmentSituation
          employerName
          incomingSource
          contractType
          numberPayRentsInAdvance
        }
      }
    }
  }
`;

export type UserCreditStudyResponse = {
  getUserCreditStudy: { value: CreditStudyResponseDto | null | undefined };
};
